<div class="container-fluid px-0" style="overflow-x: hidden">
  <div class="row">
    <div class="col-12 col-md-6 pr-md-0">
      <kendo-combobox
        style="width: 100%"
        placeholder="Type here to search an asset"
        [data]="searchAssetList"
        [valueField]="'assetNumber'"
        [textField]="'assetNumber'"
        [filterable]="true"
        (filterChange)="handleAssetSearchFilter($event)"
        (valueChange)="handleAssetSearchValue($event)"
      >
      </kendo-combobox>
    </div>
  </div>
  <div class="row" style="margin-top: 3px">
    <div class="col-12">
      <kendo-splitter [orientation]="kendoSplitterOrientation">
        <kendo-splitter-pane size="50%" min="25%">
          <div class="row mx-0">
            <div class="col-12">
              <legend class="text-decoration-underline">Assets</legend>
              <div class="asset-hierarchy">
                <kendo-treeview
                  #assetHierarchyKendo
                  [nodes]="assetsList"
                  textField="assetNumber"
                  kendoTreeViewExpandable
                  kendoTreeViewSelectable
                  kendoTreeViewHierarchyBinding
                  [(expandedKeys)]="expandedKeys"
                  [(selectedKeys)]="selectedKeys"
                  [isSelected]="isItemSelected"
                  (childrenLoaded)="handleChildrenLoaded($event)"
                  (selectionChange)="handleSelection($event)"
                  [children]="fetchChildren"
                  [hasChildren]="hasChildren"
                >
                </kendo-treeview>
              </div>
            </div>
          </div>
        </kendo-splitter-pane>

        <kendo-splitter-pane min="25%">
          <div class="row mx-0">
            <div class="col-12">
              <legend class="text-decoration-underline">Attributes</legend>
              <fieldset class="attributes">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Asset Number:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <button
                        class="hyperlink"
                        (click)="takeToNode(attributeList['assetNumber'])"
                      >
                        {{ attributeList.assetNumber }}
                      </button>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Parent Asset Number:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <button
                        class="hyperlink"
                        (click)="takeToNode(attributeList['c1'])"
                      >
                        {{ attributeList.c1 }}
                      </button>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Active:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      {{ attributeList.activeFlag }}
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Node ID:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <button
                        class="hyperlink"
                        (click)="takeToNode(attributeList['c5'])"
                      >
                        {{ attributeList.c5 }}
                      </button>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Active Start Date:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      {{
                        attributeList.activeStartDate | date: "dd / MMM / yyyy"
                      }}
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Active End Date:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      {{ attributeList.activeEndDate | date: "dd / MMM / yyyy" }}
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Level Number:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      {{ attributeList.levelNumber }}
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Shutdown Impacts Production:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <span
                        class="prod-impact"
                        [ngClass]="{
                          unknown:
                            attributeList['assetsImpactsProduction'] ==
                            'Unknown',
                          impact:
                            attributeList['assetsImpactsProduction'] ==
                            'Impact Production',
                          'no-impact':
                            attributeList['assetsImpactsProduction'] ==
                            'No Impact'
                        }"
                      >
                        {{ attributeList.assetsImpactsProduction }}</span
                      >
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Inherits from:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <button
                        class="hyperlink"
                        (click)="takeToNode(attributeList['assetNumber1'])"
                      >
                        {{ attributeList.assetNumber1 }}
                      </button>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      <b>Description:</b>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label class="k-form-field">
                      {{ attributeList.assetDescription }}
                    </label>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="row my-2">
                  <div class="col-12 text-center">
                    <div class="btn-group mt-2">
                      <button
                        type="button"
                        class="btn btn-secondary inherit"
                        (click)="checkImpactProductionConfirmation('i')"
                      >
                        I
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary inherit"
                        (click)="checkImpactProductionConfirmation('i+')"
                      >
                        I+
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary inherit"
                        (click)="checkImpactProductionConfirmation('i++')"
                      >
                        I++
                      </button>
                    </div>
                    <div class="btn-group mt-2 ml-sm-2">
                      <button
                        type="button"
                        class="btn btn-secondary yes-button"
                        (click)="checkImpactProductionConfirmation('y')"
                      >
                        Y
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary yes-button"
                        (click)="checkImpactProductionConfirmation('y+')"
                      >
                        Y+
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary yes-button"
                        (click)="checkImpactProductionConfirmation('y++')"
                      >
                        Y++
                      </button>
                    </div>
                    <div class="btn-group mt-2 ml-sm-2">
                      <button
                        type="button"
                        class="btn btn-secondary no-button"
                        (click)="checkImpactProductionConfirmation('n')"
                      >
                        N
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary no-button"
                        (click)="checkImpactProductionConfirmation('n+')"
                      >
                        N+
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary no-button"
                        (click)="checkImpactProductionConfirmation('n++')"
                      >
                        N++
                      </button>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </kendo-splitter-pane>
      </kendo-splitter>
    </div>
  </div>
</div>
